import navItems from "../../translation/nav.json";
import NavOption from "../nav/NavOption";

function NavOptions({ currentLanguage, handleNavItemClick }) {
  return (
    <div className="nav-options-container">
      <ul className="nav-options">
        {navItems.map((item, index) => (
          <NavOption
            item={item}
            key={index}
            handleNavItemClick={handleNavItemClick}
            currentLanguage={currentLanguage}
          />
        ))}
      </ul>
    </div>
  );
}

export default NavOptions;
